import type { MailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isEnabledForFrontierCopilotAudience } from './isEnabledForFrontierCopilotAudience';

export function isMeetingPrepPrereadEnabled(mailboxInfo: MailboxInfo): boolean {
    return (
        isGlobalFeatureEnabled('time-copilot-meeting-prep-preread') ||
        isMeetingPrepPrereadFrontierEnabled(mailboxInfo)
    );
}

export function isMeetingPrepPrereadFrontierEnabled(mailboxInfo: MailboxInfo): boolean {
    return isEnabledForFrontierCopilotAudience(mailboxInfo, {
        publicFlight: 'time-copilot-meeting-prep-preread-frontier-public',
        privateTapFlight: 'time-copilot-meeting-prep-preread-frontier-private-tap',
        privateStagingFlight: 'time-copilot-meeting-prep-preread-frontier-private-staging',
        privateInfluencerFlight: 'time-copilot-meeting-prep-preread-frontier-private-influencer',
    });
}
